/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { AxiosInstance, AxiosRequestConfig } from "axios";
import { getApiBasePath } from "../utils/envUtil";
import { EcgActionSeverity } from "../models/ecg.interface";
import { ClientAccessUserPermission } from "../models/token.interface";

export interface IRequestOptions extends AxiosRequestConfig { }

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = { axios: axiosStatic };

// Instance selector
export function axios(
  configs: IRequestConfig,
  resolve: (p: any) => void,
  reject: (p: any) => void
): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    throw new Error("please inject yourself instance like axios  ");
  }
}

// Instance selector
export function axiosResponse(
  configs: IRequestConfig,
  resolve: (p: any) => void,
  reject: (p: any) => void
): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    throw new Error("please inject yourself instance like axios  ");
  }
}

export function getConfigs(
  method: string,
  contentType: string,
  url: string,
  options: any
): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url };
  configs.headers = {
    ...options.headers,
    "Content-Type": contentType,
  };
  return configs;
}

export const basePath = getApiBasePath();

export interface IList<T> extends Array<T> { }
export interface List<T> extends Array<T> { }
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> { }

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export interface LoginDto {
  /**  */
  email?: string;

  /**  */
  password?: string;

  /**  */
  tryOtherBackends?: boolean;
}

export interface AuthenticateApiUserDto {
  /**  */
  email?: string;

  /**  */
  password?: string;
}

export interface GetAutoLoginUrlDto {
  /**  */
  apiUserName: string;

  /**  */
  apiPassword: string;

  /**  */
  userName: string;
}

export interface CreateDistDto {
  /** The new distributor name */
  distName: string;

  /** The distributor id that new distriubutor belongs to */
  parentDistId: number;

  /** State name (NY, TX etc...). If not relevant can be the country name (Israel, Germany etc...) */
  state: string;

  /** Country code. For example: 1 for USA, 44 for UK etc... */
  country: number;

  /**  */
  city?: string;

  /**  */
  street?: string;

  /** The phone number of the distributor. */
  phoneNumber?: string;

  /**  */
  referenceNumber?: string;

  /** The email address of the distributor */
  email?: string;

  /**  */
  ecgStateByClinic?: boolean;
}

export interface ShApiResponse_GetDistributorDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetDistributorDto;
}

export interface ApiError {
  /**  */
  errorCode?: IApiErrorErrorCode;

  /**  */
  errorMessage?: string;
}

export interface GetDistributorDto {
  /**  */
  id: number;

  /**  */
  name: string;

  /**  */
  rootDistributorName?: string;

  /**  */
  parentDistId: number;

  /**  */
  phoneNumber: string;

  /**  */
  referenceNumber: string;

  /**  */
  state: string;

  /**  */
  country: number;

  /**  */
  email: string;

  /**  */
  usersCount: number;

  /**  */
  activeUsersCount: number;

  /**  */
  usesOrders?: boolean;

  /**  */
  serviceType?: IGetDistributorDtoServiceType;

  /**  */
  stateId?: number;

  /**  */
  sla?: number;

  /**  */
  maxLevelOfEntities?: number;

  /**  */
  levelInTree?: number;

  /**  */
  ecgStateByClinic?: boolean;
}

export type BasicTreeNodeDataType = { id: number, name: string };
export interface TreeNode<T> {
  /**  */
  data: T;

  /**  */
  children?: TreeNode<T>[];
}

export interface ProEntitiesTree {
  /**  */
  nodeCount?: number;

  /**  */
  root?: TreeNode<BasicTreeNodeDataType>;
}

export interface ShApiResponse_ProEntitiesTree {
  /**  */
  error?: ApiError;

  /**  */
  response?: ProEntitiesTree;
}

export interface UpdateDistDto {
  /**  */
  distName?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  referenceNumber?: string;

  /**  */
  email?: string;
}

export interface ShApiResponse_Boolean {
  /**  */
  error?: ApiError;

  /**  */
  response?: boolean;
}

export interface ShApiResponse_Tree_GetDistributorDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: Tree_GetDistributorDto;
}

export interface Tree_GetDistributorDto {
  /**  */
  totalUsers?: number;

  /**  */
  totalActiveUsers?: number;

  /**  */
  nodeCount?: number;

  /**  */
  root?: TreeNode_GetDistributorDto;
}

export interface ShApiResponse_List_GetDistributorDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetDistributorDto[];
}

export interface ShApiResponse_IEnumerable_GetDistributorDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetDistributorDto[];
}

export interface ShApiResponse_GetUserPermissionsDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetUserPermissionsDto;
}

export interface GetUserPermissionsDto {
  /**  */
  userPermissions?: UserPermissions;
}

export interface UserPermissions {
  /**  */
  canManageNonProUsers?: UserPermission;
  canViewEcgs?: UserPermission;
  canEditInterpretation?: UserPermission;
  canManageProUsers?: UserPermission;
  canViewReports?: UserPermission;
  canLogIntoPortal?: UserPermission;
  canViewSelfClinicsEcgs?: UserPermission;
  canSendEcgsViaMail?: UserPermission;
  canApproveEcg?: UserPermission;
  canArchiveEcgs?: UserPermission;
  showEcgPreview?: UserPermission;
}

export interface UserPermission {
  /**  */
  defaultValue?: boolean;

  /**  */
  isPermissionAllowed?: boolean;
}

export interface ShApiResponse_IEnumerable_GetActionDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetActionDto[];
}

export interface GetActionDto {
  /**  */
  name: string;

  /**  */
  severity?: number;

  /**  */
  emergencyNumber?: string;

  /**  */
  acceptDate?: string;

  /**  */
  code: number;

  /**  */
  value: boolean;
}

export interface ShApiResponse_IEnumerable_Symptom {
  /**  */
  error?: ApiError;

  /**  */
  response?: Symptom[];
}

export interface Symptom {
  /** The unique id of the symptom */
  symptomsId?: string;

  /** The descriptive name of the symptom */
  symptomName?: string;
}

export interface ShApiResponse_EcgCollectionData {
  /**  */
  error?: ApiError;

  /**  */
  response?: EcgCollectionData;
}

export interface EcgCollectionData {
  /**  */
  ecgs?: EcgData[];

  /** The 12 leads graph png images encoded to a base64 string. */
  leads?: EcgLeads;
}

export interface EcgData {
  /** The remarks the user has entered during the ECG transmission process. */
  remarks?: string;

  /** Technical instructions to improve the ECG quality. Given automatically based on the ECG quality and MC input. */
  technicalInstructions?: string;

  /** The status of the Smartheart electrodes during the ECG transmission */
  electrodesStatus?: ElectrodesStatus;

  /** The ECG measurements values. May be confirmed (done and saved by the MC, when there's a service) or unconfirmed (automatic, done
using an algorithm). */
  measurements?: EcgMeasurements;

  /** The symptos the user has selected during the ECG transmissionn process. */
  symptoms?: Symptom[];

  /** The permissions related to the ecg */
  permissions?: GetEcgPermissionsDto;

  /** List of Ecg findings */
  findings?: GetFindingDto[];

  /** List of Ecg actions */
  actions?: GetActionDto[];

  /** Actions review note */
  actionsReviewNote?: string;

  /** List of Ecg comments */
  comments?: GetCommentDto[];

  /** The Ecg interpertation */
  interpretation?: GetInterpretationDto;

  /** The Ecg priority flag */
  isPriority?: GetIsPriorityDto;

  /** The Ecg approved details */
  approve?: GetEcgApproveDto;

  /** The serial number of the device */
  deviceSN?: string;

  /** The profile refrence */
  reference?: string;

  /** The timeout for the review session in minutes */
  timeout?: number;

  /** Indicates whether the profile defined with pacemaker */
  hasPacemaker?: boolean;

  /** s
            Gets the ecg's review state */
  ecgReviewState?: IEcgDataEcgReviewState;

  isUnreadableBySystem?: boolean;
}

export interface EcgLeads {
  /**  */
  rhythm?: string;

  /**  */
  l1?: string;

  /**  */
  l2?: string;

  /**  */
  l3?: string;

  /**  */
  avr?: string;

  /**  */
  avl?: string;

  /**  */
  avf?: string;

  /**  */
  v1?: string;

  /**  */
  v2?: string;

  /**  */
  v3?: string;

  /**  */
  v4?: string;

  /**  */
  v5?: string;

  /**  */
  v6?: string;
}

export interface ElectrodesStatus {
  /**  */
  ll?: boolean;

  /**  */
  la?: boolean;

  /**  */
  ra?: boolean;

  /**  */
  v1?: boolean;

  /**  */
  v2?: boolean;

  /**  */
  v3?: boolean;

  /**  */
  v4?: boolean;

  /**  */
  v5?: boolean;

  /**  */
  v6?: boolean;
}

export interface EcgMeasurements {
  /** Indicates whether the measurements are unconfirmed (automatic) or not */
  isUnconfirmed?: boolean;

  /** Indicates whether the measurements values units are in ms (or seconds). 
Note: The Rate (pulse) measurement is always in bpm */
  isMs?: boolean;

  /** The rate (pulse) ECG measurement */
  rate?: string;

  /** The PR ECG measurement */
  pr?: string;

  /** The Qrs ECG measurement */
  qrs?: string;

  /** The QT ECG measurement */
  qt?: string;

  /** The QTcB ECG measurement */
  qtcb?: string;

  /** The QTcF ECG measurement */
  qtcf?: string;
}

export interface GetEcgPermissionsDto {
  /**  */
  enableLeads: GetEcgFindingLeadsPermissionDto[];

  /**  */
  findingsRequired: boolean;

  /**  */
  enableFindings: boolean;

  /**  */
  enableActions: boolean;

  /**  */
  enableInterpretation: boolean;

  /**  */
  enablePriority: boolean;

  /**  */
  enableNotes: boolean;

  /**  */
  interpretationRequired: boolean;

  /**  */
  enableApprove: boolean;

  /**  */
  showSuggestiveOf: boolean;

  /**  */
  saveOnce: boolean;

  /**  */
  archiving: Archiving;

  /**  */
  canSendEcgsViaMail: boolean;

  /** Indicates whether the user can request an external review on demand */
  canRequestECROnDemand: CanRequestEcrOnDemandDto;
}

export interface GetFindingDto {
  /**  */
  name: string;

  /**  */
  category: string;

  /**  */
  isEditable: boolean;

  /**  */
  leads?: GetLeadDto[];

  /**  */
  code: number;

  /**  */
  value: boolean;
}

export interface GetCommentDto {
  /**  */
  text: string;

  /**  */
  edit: EditDetails;
}

export interface GetInterpretationDto {
  /**  */
  text: string;

  /**  */
  edit: EditDetails;
}

export interface GetIsPriorityDto {
  /**  */
  value: boolean;
}

export interface GetEcgApproveDto {
  /**  */
  ecgId: string;

  /**  */
  edit: EditDetails;
}

export interface GetEcgFindingLeadsPermissionDto {
  /**  */
  findingCode: number;

  /**  */
  useLeads: boolean;
}

export interface Archiving {
  /**  */
  canBeArchived: boolean;

  /**  */
  isReviewCompleted: boolean;
}

export interface CanRequestEcrOnDemandDto {
  /**  */
  state?: ICanRequestEcrOnDemandDtoState;

  /**  */
  rejectReason?: ICanRequestEcrOnDemandDtoRejectReason;
}

export interface GetLeadDto {
  /**  */
  name: string;

  /**  */
  code: number;

  /**  */
  value: boolean;
}

export interface EditDetails {
  /**  */
  userId?: string;

  /**  */
  salutation?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  date?: string;
}

export interface CreateEcgDraftDto {
  /**  */
  findings: CreateFindingDto[];

  /**  */
  actions: CreateActionDto[];

  /**  */
  interpretation: CreateInterpretationDto;

  /**  */
  isPriority: CreateIsPriorityDto;
}

export interface CreateFindingDto {
  /**  */
  leads?: CreateLeadDto[];

  /**  */
  code: number;

  /**  */
  value: boolean;
}

export interface CreateActionDto {
  /**  */
  code: number;

  /**  */
  value: boolean;
}

export interface CreateInterpretationDto {
  /**  */
  text: string;
}

export interface CreateIsPriorityDto {
  /**  */
  value: boolean;
}

export interface CreateLeadDto {
  /**  */
  code: number;

  /**  */
  value: boolean;
}

export interface ShApiResponse_UpdateSaveResponse {
  /**  */
  error?: ApiError;

  /**  */
  response?: UpdateSaveResponse;
}

export interface UpdateSaveResponse {
  /**  */
  draft?: UpdateDraftResponse;

  /**  */
  ecgReady?: UpdateEcgResponse;

  /**  */
  ecgPdfRecreate?: GetEcgPdfRecreateDto;

  /**  */
  postSaveMessageCode?: IUpdateSaveResponsePostSaveMessageCode;
}

export interface UpdateDraftResponse {
  /**  */
  findings?: UpdateFindingsResponse;

  /**  */
  actions?: UpdateActionsResponse;

  /**  */
  interpretation?: UpdateInterpretationResponse;

  /**  */
  isPriority?: UpdateIsPriorityResponse;
}

export interface UpdateEcgResponse {
  /**  */
  ecg?: GetEcgReadyDto;

  /**  */
  edit?: EditDetails;
}

export interface GetEcgPdfRecreateDto {
  /**  */
  ecgId?: string;
}

export interface UpdateFindingsResponse {
  /**  */
  findings?: CreateResponseFindingDto[];

  /**  */
  edit?: EditDetails;
}

export interface UpdateActionsResponse {
  /**  */
  actions?: CreateActionDto[];

  /**  */
  edit?: EditDetails;
}

export interface UpdateInterpretationResponse {
  /**  */
  interpretation?: CreateInterpretationDto;

  /**  */
  edit?: EditDetails;
}

export interface UpdateIsPriorityResponse {
  /**  */
  isPriority?: CreateIsPriorityDto;
}

export interface GetEcgReadyDto {
  /**  */
  ecgId: string;

  /**  */
  ecgReady?: number;

  /**  */
  updaterPointer?: number;
}

export interface CreateResponseFindingDto {
  /**  */
  leads?: string;

  /**  */
  code: number;

  /**  */
  value: boolean;
}

export interface ShApiResponse_GetEcgApproveDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetEcgApproveDto;
}

export interface ShApiResponse_IEnumerable_GetCommentDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetCommentDto[];
}

export interface CreateCommentDto {
  /**  */
  text: string;
}

export interface ShApiResponse_UpdateCommentResponse {
  /**  */
  error?: ApiError;

  /**  */
  response?: UpdateCommentResponse;
}

export interface UpdateCommentResponse {
  /**  */
  comment?: CreateCommentDto;

  /**  */
  edit?: EditDetails;
}

export interface SendEcgByMailDto {
  /**  */
  emails: string[];
}

export interface GetEcgPdfByTokenDto {
  /** The ECG pdf bytes */
  pdfToken: string;

  /**  */
  userName?: string;

  /**  */
  password?: string;

  /**  */
  authToken?: string;

  /**  */
  ssoToken?: string;
}

export interface GetPrescriptionPdfByTokenDto {
  /**  */
  token: string;
}

export interface ShApiResponse_GetEcgPdfDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetEcgPdfDto;
}

export interface ShApiResponse_GetPrescriptionPdfDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetPrescriptionPdfDto;
}

export interface GetEcgPdfDto {
  /** The ECG pdf bytes */
  ecgPdfBytes: string;
}

export interface GetPrescriptionPdfDto {
  /** The prescription pdf bytes */
  prescriptionPdfBytes: string;
}

export interface GetLastEcgPdfDto {
  /**  */
  apiUserName: string;

  /**  */
  apiUserPassword: string;

  /**  */
  ecgOwnerUserName: string;

  /**  */
  patientReference: string;

  /**  */
  patientFirstName: string;

  /**  */
  patientLastName: string;
}

export interface ShApiResponse_UpdateDraftResponse {
  /**  */
  error?: ApiError;

  /**  */
  response?: UpdateDraftResponse;
}

export interface ShApiResponse_GetEcgPermissionsDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetEcgPermissionsDto;
}

export interface ShApiResponse_GetInterpretationDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetInterpretationDto;
}

export interface ShApiResponse_IEnumerable_GetFindingDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetFindingDto[];
}

export interface ShApiResponse_Int32 {
  /**  */
  error?: ApiError;

  /**  */
  response?: number;
}

export interface PostHealthCheckEcgDto {
  /**  */
  userId?: string;

  /**  */
  profileId?: string;
}

export interface ShApiResponse_GetEcgDataValidationDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetEcgDataValidationDto;
}

export interface GetEcgDataValidationDto {
  /** The ECG unique identifier */
  ecgId: string;

  /** Indicates whether The ECG is unreadable */
  isUnreadable?: boolean;

  /** The ECG technical instruction */
  instruction?: string;
}

export interface ShApiResponse_IEnumerable_GetStaticLinksDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetStaticLinksDto[];
}

export interface GetStaticLinksDto {
  /** Type of link */
  linkType: string;

  /** Device type related to the link IOS/ANDROID */
  deviceType: string;

  /** Link URL */
  url: string;
}

export interface ShApiResponse_IEnumerable_GetStaticLinksByRoleDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetStaticLinksByRoleDto[];
}

export interface GetStaticLinksByRoleDto {
  /** Enum Type of StaticLinkTypeByRole */
  linkType: IGetStaticLinksByRoleDtoLinkType;

  /** Role id */
  roleId: number;

  /** Link URL */
  url: string;
}

export interface ShApiResponse_List_String {
  /**  */
  error?: ApiError;

  /**  */
  response?: string[];
}

export interface ShApiResponse_GetFollowUpReportDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetFollowUpReportDto;
}

export interface GetFollowUpReportDto {
  /** The report data */
  reportData: string;
}

export interface ShApiResponse_String {
  /**  */
  error?: ApiError;

  /**  */
  response?: string;
}

export interface ShApiResponse_GetLatestFirmwareDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetLatestFirmwareDto;
}

export interface GetLatestFirmwareDto {
  /**  */
  fwVersion?: number;

  /**  */
  actionType?: IGetLatestFirmwareDtoActionType;
}

export interface ShApiResponse_GetCancelSubjectOrderDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetCancelSubjectOrderDto;
}

export interface GetCancelSubjectOrderDto {
  /**  */
  cancelledDetails: EditDetails;

  /**  */
  orderNumber: string;

  /**  */
  studyName: string;

  /**  */
  subjectId: string;

  /**  */
  createdDetails: EditDetails;
}

export interface ShApiResponse_List_GetProfileDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetProfileDto[];
}

export interface GetProfileDto {
  /**  */
  id?: string;

  /**  */
  userId?: string;

  /**  */
  beltSize?: string;

  /**  */
  hasNewEcgInfo?: boolean;

  /**  */
  usState?: USState;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  gender?: string;

  /**  */
  reference?: string;

  /**  */
  pacemaker?: boolean;

  /**  */
  birthDate?: string;

  /**  */
  mrn?: string;

  /**  */
  unviewedEcgsCount?: number;

  /**  */
  lastEcgDateTime?: string;

  /**  */
  orderNumber?: string;

  /**  */
  isArchived?: boolean;
}

export interface USState {
  /**  */
  id?: number;

  /**  */
  abbreviation?: string;

  /**  */
  name?: string;
}

export interface CreateProfileDto {
  /** The profiles first name */
  firstName: string;

  /** The profile's last name */
  lastName: string;

  /** The profile's gender (Male/Female) */
  gender: string;

  /** The profile's belt size (S/M/L/XL). Passing null or empty will result in size S (this can be changed by the user later) */
  beltSize?: string;

  /** The profile's free-text reference */
  reference?: string;

  /** Indicates whether the profile has pacemaker installed */
  pacemaker: boolean;

  /** The birth date of the profile */
  birthDate?: string;

  /** The medical reference number of the profile */
  mrn?: string;

  /** 2 letter state abbreviation of the profile */
  state?: string;
}

export interface ShApiResponse_GetProfileDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetProfileDto;
}

export interface ShApiResponse_List_Profile {
  /**  */
  error?: ApiError;

  /**  */
  response?: Profile[];
}

export interface Profile {
  /** The profile's unique identifier */
  profileId?: string;

  /** The profiles first name */
  firstName: string;

  /** The profile's last name */
  lastName: string;

  /** The profile's gender (Male/Female) */
  gender?: string;

  /** The profile's belt size (S/M/L/XL). Passing null or empty will result in size S (this can be changed by the user later) */
  beltSize?: string;

  /** The profile's free-text reference */
  reference?: string;

  /** Indicates whether the profile has pacemaker installed */
  pacemaker: boolean;

  /** The birth date of the profile */
  birthDate?: string;

  /** The medical reference number of the profile */
  mrn?: string;
}

export interface ShApiResponse_CreateProfilesResponse {
  /**  */
  error?: ApiError;

  /**  */
  response?: CreateProfilesResponse;
}

export interface CreateProfilesResponse {
  /** List of created profile ids */
  profileIDs?: string[];

  /** List of profiles that were NOT created */
  invalid?: Profile[];
}

export interface UpdateProfileDto {
  /**  */
  gender?: string;

  /**  */
  beltSize?: string;

  /**  */
  mrn?: string;

  /**  */
  isDeleted?: boolean;

  /**  */
  reference?: string;

  /**  */
  studyId?: number;

  /**  */
  birthDate?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  isArchived?: boolean;

  /** Indicates whether the profile has pacemaker installed */
  pacemaker?: boolean;

  /** 2 letter state abbreviation of the profile */
  state?: string;
}

export interface ShApiResponse_Profile {
  /**  */
  error?: ApiError;

  /**  */
  response?: Profile;
}

export interface ShApiResponse_List_ProfileEcg {
  /**  */
  error?: ApiError;

  /**  */
  response?: ProfileEcg[];
}

export interface ProfileEcg {
  /** The unique identifier of the ECG */
  ecgId: string;

  /** The ECG date and time */
  ecgDateTime: string;

  /** ECG priority flag */
  isPriority: boolean;

  /** Was the ECG viewed in portal by the requesting user */
  unviewedInPortal: boolean;

  /** The user defined reference for the profile */
  reference?: string;

  /** The serial number of the Smartheart device */
  deviceSn?: string;
}

export interface ShApiResponse_Byte {
  /**  */
  error?: ApiError;

  /**  */
  response?: string;
}

export interface ShApiResponse_EcgMetaData {
  /**  */
  error?: ApiError;

  /**  */
  response?: EcgMetaData;
}

export interface EcgMetaData {
  /** The unique identifier of an ECG */
  ecgId?: string;

  /** The date/time of the ECG */
  ecgDateTime?: string;

  /** The request context of the ECG */
  requestContext?: string;

  /** The list of custom findings of the ECG */
  findings?: Finding[];

  /** Indicates whether the ECG measurements are confiremed or not */
  isConfirmedMeasurements?: boolean;

  /** The measurements of the ECG */
  measurements?: Measurements;
}

export interface Finding {
  /**  */
  name?: string;

  /**  */
  value?: string;
}

export interface Measurements {
  /** The rate (pulse) ECG measurement */
  rate?: string;

  /** The PR ECG measurement */
  pr?: string;

  /** The Qrs ECG measurement */
  qrs?: string;

  /** The QT ECG measurement */
  qt?: string;

  /** The QTcB ECG measurement */
  qtcb?: string;

  /** The QTcF ECG measurement */
  qtcf?: string;
}

export interface ShApiResponse_List_GetEcgHeaderDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetEcgHeaderDto[];
}

export interface GetEcgHeaderDto {
  /**  */
  ecgId: string;

  /**  */
  ecgDateTime: string;

  /**  */
  hasSymptoms: boolean;

  /**  */
  isUnreadable: boolean;
}

export interface ShApiResponse_GetProfileEcgListDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetProfileEcgListDto;
}

export interface GetProfileEcgListDto {
  /**  */
  ecgs?: GetProfileEcgDto[];

  /**  */
  totalCount?: number;

  /**  */
  actualCount?: number;
}

export interface GetProfileEcgDto {
  /** The ECG unique identifier */
  ecgId: string;

  /** The ECG date/time */
  ecgDateTime: string;

  /** Indicates whether the ECG is yet unviewed in the portal */
  unviewedInPortal: boolean;

  /** Indicates whether the ECG has findings */
  hasFindings: boolean;

  /** Indicates whether the ECG has new info that the user haven't seen yet */
  hasNewInfo: boolean;

  /**  */
  hasSymptoms: boolean;

  /** Indicates whether the ECG is unreadable or readable */
  isUnreadable: boolean;
}

export interface ShApiResponse_List_GetTreeViewEcgDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetTreeViewEcgDto[];
}

export interface GetTreeViewEcgDto {
  /** The ECG unique identifier */
  ecgId?: string;

  /** The ECG local created date */
  ecgDateTime?: string;

  /** Indicates whether the ECG is yet unviewed in the portal */
  unviewedInPortal?: boolean;

  /** Indicates whether the ECG has new info (interpretation/findings) that is unviewed by the requesting user */
  hasNewInfo?: boolean;

  /** Indicates whether the ECG is created in the last 24 hours */
  isCreatedInLast24Hours?: boolean;

  /** Indicates whether the ECG has Findings */
  hasFindings?: boolean;

  /** Indicates whether the ECG has interpretation */
  hasInterpretation?: boolean;

  /** Indicates whether the ECG is unreadable */
  isUnreadable?: boolean;

  /** Indicates whether the ECG is urgent */
  isPriority?: boolean;

  /** Reference to the ECG's profile */
  profile?: GetTreeViewProfileDto;
}

export interface GetTreeViewProfileDto {
  /**  */
  id: string;

  /**  */
  gender: string;

  /**  */
  birthDate: string;
}

export interface ShApiResponse_List_USState {
  /**  */
  error?: ApiError;

  /**  */
  response?: USState[];
}

export interface ShApiResponse_GetOrganizationStudiesDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetOrganizationStudiesDto;
}

export interface GetOrganizationStudiesDto {
  /**  */
  totalStudies?: number;

  /**  */
  totalActiveStudies?: number;

  /**  */
  totalUsers?: number;

  /**  */
  totalActiveUsers?: number;

  /**  */
  totalSubjects?: number;

  /**  */
  studies?: GetStudyDto[];
}

export interface GetStudyDto {
  /**  */
  id: string;

  /**  */
  name: string;

  /**  */
  reference?: string;

  /**  */
  activelyLinkedUsersCount: number;

  /**  */
  totalLinkedUsersCount: number;

  /**  */
  users: GetStudyUserDto[];

  /**  */
  isActive?: boolean;

  /**  */
  subjectCount: number;

  /**  */
  visits: GetVisitDto[];

  /**  */
  ecgsCount: number;
}

export interface GetStudyUserDto {
  /**  */
  id: string;

  /**  */
  name: string;

  /**  */
  isLinkActive: boolean;

  /**  */
  canApproveEcgs: boolean;
}

export interface GetVisitDto {
  /**  */
  id?: string;

  /**  */
  name?: string;

  /**  */
  hasOrders?: boolean;
}

export interface ShApiResponse_List_GetStudyDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetStudyDto[];
}

export interface CreateStudyDto {
  /**  */
  name: string;

  /**  */
  reference?: string;

  /**  */
  visits: CreateVisitDto[];
}

export interface CreateVisitDto {
  /**  */
  name: string;
}

export interface ShApiResponse_GetStudyDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetStudyDto;
}

export interface UpdateStudyDto {
  /**  */
  name?: string;

  /**  */
  reference?: string;

  /**  */
  isActive?: boolean;

  /**  */
  visits?: UpdateVisitDto[];
}

export interface UpdateVisitDto {
  /**  */
  id?: string;

  /**  */
  name?: string;
}

export interface CreateSubjectOrderDto {
  /**  */
  subjectId: string;

  /**  */
  subjectGender: string;

  /**  */
  subjectYearOfBirth: number;

  /**  */
  visitId: string;
}

export interface ShApiResponse_GetSubjectOrderDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetSubjectOrderDto;
}

export interface GetSubjectOrderDto {
  /**  */
  orderNumber: string;

  /**  */
  studyName: string;

  /**  */
  subjectId: string;

  /**  */
  createdDetails: EditDetails;
}

export interface UpdateStudyUserDto {
  /**  */
  userId: string;

  /**  */
  isActive: boolean;
}

export interface ShApiResponse_GetSubjectDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetSubjectDto;
}

export interface GetSubjectDto {
  /**  */
  subjectId?: string;

  /**  */
  gender?: IGetSubjectDtoGender;

  /**  */
  yearOfBirth?: number;

  /**  */
  nextVisitId?: string;

  /**  */
  order?: SubjectOrder;

  /**  */
  existsInOtherStudyName?: string;
}

export interface SubjectOrder {
  /**  */
  orderNumber?: string;

  /**  */
  canCancel?: boolean;

  /**  */
  visitId?: string;
}

export interface CreateSubscriptionDto {
  /**  */
  custPointer: number;

  /**  */
  orderId: string;

  /**  */
  orderDate?: string;

  /**  */
  numOfReviews: number;

  /**  */
  numOfTeleHealthVisits: number;

  /**  */
  packageDurationMonths: number;

  /**  */
  deviceType: string;
}

export interface ShApiResponse_GetSubscriptionDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetSubscriptionDto;
}

export interface GetSubscriptionDto {
  /**  */
  id?: string;

  /**  */
  createDate?: string;

  /**  */
  userId?: string;

  /**  */
  orderId?: string;

  /**  */
  startDate?: string;

  /**  */
  endDate?: string;

  /**  */
  status?: IGetSubscriptionDtoStatus;

  /**  */
  numOfReviews?: number;

  /**  */
  numOfTeleHealthVisits?: number;

  /**  */
  packageDurationMonths?: number;

  /**  */
  cancelRequestDate?: string;

  /**  */
  deviceType?: string;
}

export interface CancelSubscriptionDto {
  /**  */
  cancelRequestDate: string;

  /**  */
  cancelDate: string;
}

export interface LoginData {
  /**  */
  email?: string;

  /**  */
  password?: string;

  /**  */
  token?: string;
}

export interface ShApiResponse_FullSmartheartUser {
  /**  */
  error?: ApiError;

  /**  */
  response?: FullSmartheartUser;
}

export type ShApiResponse_AuthenticateApiUser = { data: string, status: number };

export interface FullSmartheartUser {
  /** The period to wait when a Smartheart device is rejected by the user until it will try to connect again */
  smartheartRejectionPeriod?: number;

  /** Indicates whether the user can choose to skip the guidance screen */
  allowSkipGuidanceScreen?: boolean;

  /** Indicates whether the user password has expired */
  passwordExpired: boolean;

  /** The ECG transmission channel times that should be passed to the Smartheart device */
  smartheartChannelsTimes?: number[];

  /** The ECG sampling rate that should be passed to the Smartheart device */
  smartheartSamplingRate?: number;

  /** The ECG Preview channel times that should be passed to the Smartheart device */
  smartheartPreviewChannelsTimes?: number[];

  /** The ECG Preview sampling rate that should be passed to the Smartheart device */
  smartheartPreviewSamplingRate?: number;

  /** The baseline timeout value that should be passed to the Smarthear device */
  smartheartBaselineTimeout?: number;

  /** The Preview threshold */
  smartheartPreviewThreshold?: number;

  /** Indicates whether the user should skip the symptoms screen */
  skipSymptoms?: boolean;

  /** The backend url that the logged user shold work with */
  backendUrl?: string;

  /**  */
  ecgWSUrl?: string;

  /** The total number of unviewed ECGs of the user */
  unviewedEcgs?: number;

  /**  */
  signInUrl?: string;

  /**  */
  signOutUrl?: string;

  /**  */
  isSso?: boolean;

  /**  */
  canSendEcgViaEmail: boolean;

  /**  */
  canAddProfiles: boolean;

  /**  */
  autoSendEcg?: boolean;

  /**  */
  canViewSelfClinicEcgs: boolean;

  /**  */
  isNewAppAllowed?: boolean;

  /**  */
  canArchiveEcgs: boolean;

  /**  */
  canArchiveProfiles: boolean;

  /**  */
  canManageProUsers: boolean;

  clientAccessUserPermission: ClientAccessUserPermissionion;

  /**  */
  canManageEntities: boolean;

  /**  */
  showTreeViewCounters?: boolean;

  /**  */
  isTreeViewSelected?: boolean;

  /**  */
  isTreeViewAllowed?: boolean;

  /**  */
  canViewEntities?: boolean;

  /**  */
  canManageEntities?: boolean;

  /**  */
  isProfileStateRequired?: boolean;

  /**  */
  isConsumer?: boolean;

  /** Indicates the user role
1 = Patient (Legacy),
2 = Physician (Legacy),
3 = Nurse (Legacy),
4 = ApiUser (Legacy),
5 = NonProfessionalStandalone,
6 = ProfessionalStandalone,
7 = NonProfessionalOrganization,
8 = ProfessionalOrganization,
9 = ProfessionalOrganizationAdmin,
10 = ProfessionalEcgReviewer */
  roleId: IFullSmartheartUserRoleId;

  /** Indicates whether the Smartheart Preview is enabled for the user */
  smartheartPreviewEnabled?: boolean;

  /** The maximum number of profiles the user can add. Infinite if null. */
  maxProfiles?: number;

  /** Indicates whether the QtcF values should be displayed. Else, the QtcB value should be displayed. */
  useQtcF: boolean;

  /** Indicates whether to show the automatic measurements of an ECG to the user or not. */
  showAutoMeasurements: boolean;

  /** The organization the user belongs to. Null if the user doesn't belong to an organization. */
  organization?: Organization;

  /** Indicates whether the user can log into the portal (or only to the apps) */
  canLogIntoPortal: boolean;

  /** Indicates whether the user can view all ecgs of the organization */
  canViewEcgs: boolean;

  /** Indicates whether the user can edit ecgs interpretations */
  canEditInterpretation: boolean;

  /** Indicates whether the user can manage non pro users */
  canManageNonProUsers: boolean;

  /** Indicates whether the user can view and download ecg reports */
  canViewReports: boolean;

  /** Indicates whether the user can approve ecg */
  canApproveEcg: boolean;

  /** The unique identifier of the user */
  id: string;

  /** The first name of the user */
  firstName: string;

  /** The last name of the user */
  lastName: string;

  /** The salutation of the user */
  salutation?: string;

  /** The user name (email) of the user */
  userName: string;

  /** The password of the user */
  password?: string;

  /** Indicates whether the user has ECG interpretation service or not. If null or empty - a generated password will be created */
  withService?: boolean;

  /** Indicates whether the user is enabled or not.
When creating an organization user, if set to false the created user is disabled and the proper 
activation process will be initialized. */
  enabled: boolean;

  /**  */
  phoneNumber?: string;
}

export interface Organization {
  /** Thd unique identifier of the entity */
  organizationId: number;

  /** The display name of the organization */
  organizationName: string;

  /** The type of the organization */
  organizationType?: IOrganizationOrganizationType;

  /** The service type of the organization */
  serviceType?: IOrganizationServiceType;

  /** indicates whether the organization use orders */
  useOrders?: boolean;

  IsViewSelfClinicIsAllowed: boolean;
}

export interface ShApiResponse_IEnumerable_SmartheartUser {
  /**  */
  error?: ApiError;

  /**  */
  response?: SmartheartUser[];
}

export interface SmartheartUser {
  /** The unique identifier of the user */
  id: string;

  /** The first name of the user */
  firstName: string;

  /** The last name of the user */
  lastName: string;

  /** The salutation of the user */
  salutation?: string;

  /** The user name (email) of the user */
  userName: string;

  /** The password of the user */
  password?: string;

  /** Indicates whether the user has ECG interpretation service or not. If null or empty - a generated password will be created */
  withService?: boolean;

  /** Indicates whether the user is enabled or not.
When creating an organization user, if set to false the created user is disabled and the proper 
activation process will be initialized. */
  enabled: boolean;

  /**  */
  phoneNumber?: string;
}

export interface ShApiResponse_SmartheartUser {
  /**  */
  error?: ApiError;

  /**  */
  response?: SmartheartUser;
}

export interface ShApiResponse_List_GetBasicUserDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetBasicUserDto[];
}

export interface GetBasicUserDto {
  /**  */
  id?: string;

  /**  */
  roleId?: IGetBasicUserDtoRoleId;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  salutation?: string;
}

export interface ShApiResponse_IEnumerable_GetUserDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetUserDto[];
}

export interface GetUserDto {
  /**  */
  id: string;

  /**  */
  roleId: IGetUserDtoRoleId;

  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  salutation?: string;

  /**  */
  userName: string;

  /**  */
  maxProfiles: number;

  /**  */
  enabled: boolean;

  /**  */
  organization?: Organization;

  /**  */
  withService: boolean;

  /**  */
  canLogIntoPortal: boolean;

  /**  */
  canViewEcgs: boolean;

  /**  */
  canEditInterpretation: boolean;

  /**  */
  canManageNonProUsers: boolean;

  /**  */
  canViewReports: boolean;

  /**  */
  phoneNumber?: string;

  /**  */
  dateTimeActivated?: string;

  /** 0 = Active, 1 = Disabled, 2 = Pending */
  userStatus: IGetUserDtoUserStatus;

  /**  */
  lastLoginDateTime?: string;

  /**  */
  activeProfilesCount: number;

  /**  */
  totalProfilesCount: number;

  /**  */
  dateTimeCreated: string;

  /**  */
  canApproveEcg: boolean;

  /**  */
  prescribingPhysician?: User;

  /** Birth date of the user
Format date: 'yyyy-MM-dd HH:mm:ss' */
  dateOfBirth?: string;

  /**  */
  gender?: IGetUserDtoGender;

  /** Last ecg that the user did
Format date: 'yyyy-MM-dd HH:mm:ss' */
  lastEcgDateTime?: string;

  /**  */
  deviceSN?: string;

  /**  */
  emailVerificationRequired: boolean;

  /**  */
  sendReportsByEmail: boolean;

  /**  */
  beltSize?: IGetUserDtoBeltSize;

  /**  */
  totalECGsCount?: number;

  /** Last login of the user
Format date: 'yyyy-MM-dd HH:mm:ss' */
  lastLogin?: string;

  /**  */
  profileReference?: string;

  /**  */
  canArchiveEcgs: boolean;

  /**  */
  canArchiveProfiles: boolean;

  /**  */
  canManageProUsers: boolean;

  /**  */
  isNewAppAllowed: boolean;

  /**  */
  showTreeViewCounters?: boolean;

  /**  */
  isTreeViewSelected?: boolean;

  /**  */
  isTreeViewAllowed?: boolean;

  /**  */
  canViewSelfClinicsEcgs: boolean;

  /**  */
  canSendEcgsViaMail: boolean;

  /**  */
  canViewEntities: boolean;

  /**  */
  canManageEntities: boolean;

  /**  */
  usState?: USState;

  countryCode?: string //TODO verify model

  /**  */
  canSendEcgsViaMail?: boolean;

  /**  */
  canViewSelfClinicsEcgs?: boolean;

  /**  */
  showEcgPreview?: boolean;

  /**  */
  hasPacemaker?: boolean;
}

export interface User {
  /**  */
  id?: string;

  /**  */
  pointer?: number;

  /**  */
  salutation?: string;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  organization?: Organization;
}

export interface CreateOrganizationUserDto {
  /**  */
  roleId: ICreateOrganizationUserDtoRoleId;

  /**  */
  password: string;

  /**  */
  withService?: boolean;

  /**  */
  phoneNumber?: string;

  /**  */
  enabled: boolean;

  /** Indicates whether the Smartheart Preview is enabled for the user */
  smartheartPreviewEnabled?: boolean;

  /** Indicates whether the QtcF values should be displayed. Else, the QtcB value should be displayed. */
  useQtcF?: boolean;

  /** Indicates whether to show the automatic measurements of an ECG to the user or not. */
  showAutoMeasurements?: boolean;

  /** The id of the distributor (organization/entity) the user belongs to. */
  distributorId: number;

  /** Indicates whether the user can log into the portal (or only to the apps) */
  canLogIntoPortal?: boolean;

  /** Indicates whether the user can view all ecgs of the organization */
  canViewEcgs?: boolean;

  /** Indicates whether the user can edit ecgs interpretations */
  canEditInterpretation?: boolean;

  /** Indicates whether the user can manage non pro users */
  canManageNonProUsers?: boolean;

  /** Indicates whether the user can view and download ecg reports */
  canViewReports?: boolean;

  /** The state codes (2 characters) that the user has a license to practice medicine in */
  licensedStates?: string[];

  /** A free text field for the creating user to enter. Can be used for internal information in the organization */
  reference?: string;

  /**  */
  isMale?: boolean;

  /** The user's date of birth. Passing no value will result in 1970-01-01 */
  dob?: string;

  /** Indicates whether the user can approve ecg */
  canApproveEcg?: boolean;

  /** 1 = S, 2 = M, 3 = L, 4 = XL */
  beltSize?: ICreateOrganizationUserDtoBeltSize;

  /**  */
  prescribingPhysicianId?: string;

  /** If not set to true, no email reports will be sent to the user */
  verifyEmail?: boolean;

  /** Verify email must be true in order to send reports by email */
  sendReportsByEmail?: boolean;

  /** If set to true, the new user will have to update their password on first login */
  isOneTimePassword?: boolean;

  /**  */
  licenseNumber?: string;

  /**  */
  canArchiveEcgs?: boolean;

  /**  */
  canArchiveProfiles?: boolean;

  /**  */
  isNewAppAllowed?: boolean;

  /**  */
  countryCode?: string;

  /**  */
  state?: string;

  /**  */
  businessName?: string;

  /**  */
  mrn?: string;

  /**  */
  pacemaker?: boolean;

  /**  */
  partner?: string;

  /**  */
  showTreeViewCounters?: boolean;

  /**  */
  isTreeViewSelected?: boolean;

  /**  */
  canViewEntities?: boolean;

  /**  */
  canManageEntities?: boolean;

  /**  */
  canViewSelfClinicsEcgs?: boolean;

  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  userName: string;

  /**  */
  salutation?: string;

  sendActivationEmail?: boolean;

  /**  */
  canManageProUsers?: boolean;

  /**  */
  canSendEcgsViaMail?: boolean;

  /**  */
  canViewSelfClinicsEcgs?: boolean;

  /**  */
  smartheartPreviewEnabled?: boolean
}

export interface ShApiResponse_GetUserDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetUserDto;
}

export interface UserActivationData {
  /** The activation token of the user to be activated */
  activationToken: string;

  /** The password to be set for the activated user */
  password: string;
}

export interface UpdateUserDto {
  /**  */
  updaterPointer?: number;

  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  salutation?: string;

  /**  */
  enabled?: boolean;

  /**  */
  withService?: boolean;

  /**  */
  canLogIntoPortal?: boolean;

  /**  */
  canViewEcgs?: boolean;

  /**  */
  canEditInterpretation?: boolean;

  /**  */
  canManageNonProUsers?: boolean;

  /**  */
  canViewReports?: boolean;

  /**  */
  canCreateProfiles?: boolean;

  /**  */
  canDeleteProfiles?: boolean;

  /**  */
  phoneNumber?: string;

  /**  */
  smartheartPreviewEnabled?: boolean;

  /**  */
  creatorPointer?: number;

  /**  */
  entityId?: number;

  /** If set to true, the role will change to admin. If set to false, the role will set to Professional Organization User. Only a Professional Organization User can become admin */
  isAdmin?: boolean;

  /**  */
  canManageProUsers?: boolean;

  /**  */
  canApproveEcg?: boolean;

  /**  */
  emailVerificationRequired?: boolean;

  /**  */
  sendEmails?: boolean;

  /**  */
  prescribingPhysicianId?: string;

  /**  */
  dateOfBirth?: string;

  /** Only applies when the user is of type patient account */
  beltSize?: IUpdateUserDtoBeltSize;

  /**  */
  gender?: IUpdateUserDtoGender;

  /**  */
  autoSendECGs?: boolean;

  /**  */
  userName?: string;

  /**  */
  hasPacemaker?: boolean;

  /**  */
  licenseNumber?: string;

  /**  */
  profileReference?: string;

  /**  */
  canArchiveEcgs?: boolean;

  /**  */
  canArchiveProfiles?: boolean;

  /**  */
  isNewAppAllowed?: boolean;

  /**  */
  isTreeViewAllowed?: boolean;

  /**  */
  isTreeViewSelected?: boolean;

  /**  */
  showTreeViewCounters?: boolean;

  /**  */
  canViewSelfClinicsEcgs?: boolean;

  /**  */
  canSendEcgsViaMail?: boolean;

  /**  */
  canViewEntities?: boolean;

  /**  */
  canManageEntities?: boolean;

  /**  */
  countryCode?: string;

  canSendEcgsViaMail?: boolean;

  /**  */
  canViewSelfClinicsEcgs?: boolean;

  /**  */
  pacemaker?: boolean;
}

export interface ShApiResponse_GetUserEcgsDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetUserEcgsDto;
}

export interface GetUserEcgsDto {
  /**  */
  totalCount?: number;

  /**  */
  actualCount?: number;

  /**  */
  ecgs?: GetEcgDto[];
}

export interface GetEcgDto {
  /** The ECG user unique identifier */
  userId: string;

  /** The ECG user first bane */
  firstName: string;

  /** The ECG user last name */
  lastName: string;

  /** The organization details of the ECG user */
  organization?: PortalOrganization;

  /** The profile (patient) that the ecg belongs to */
  profile: EcgProfile;

  /** The ECG unique identifier */
  ecgId: string;

  /** The serial number of the device */
  deviceSN: string;

  /** The ECG date/time */
  ecgDateTime: string;

  /** Indicates whether the ECG is yet unviewed in the portal */
  unviewedInPortal: boolean;

  /** Indicates whether the ECG was saved by a user in the portal */
  isSaved: boolean;

  /**  */
  isPriority: boolean;

  /** Indicates the minutes remaining for the ECG to be handled according to the organization SLA. Can be null. */
  minutesRemaining?: number;

  /** Indicates whether the ECG has findings */
  hasFindings: boolean;

  /** Indicates whether the ECG has interpretation */
  hasInterpretation: boolean;

  /** Indicates whether the ECG was been approved */
  isApproved: boolean;

  /** The type of review required by the ECG reviewer. 1 - Findings only, 2 - Findings and Interpretation */
  reviewType?: IGetEcgDtoReviewType;

  /**  */
  isUnreadable: boolean;

  /**  */
  isArchived: boolean;

  /**  */
  hasSymptoms: boolean;

  /**  */
  usState: USState;

  /**  */
  actionSeverity: EcgActionSeverity;
}

export interface PortalOrganization {
  /** The name of the root organization */
  rootOrganizationName: string;

  /**  */
  phone?: string;

  /**  */
  email?: string;

  /** Thd unique identifier of the entity */
  organizationId: number;

  /** The display name of the organization */
  organizationName: string;

  /** The type of the organization */
  organizationType?: IPortalOrganizationOrganizationType;

  /** The service type of the organization */
  serviceType?: IPortalOrganizationServiceType;

  /** indicates whether the organization use orders */
  useOrders?: boolean;
}

export interface EcgProfile {
  /**  */
  id: string;

  /**  */
  firstName: string;

  /**  */
  lastName: string;

  /**  */
  dateOfBirth: string;

  /**  */
  mrn?: string;

  /**  */
  reference?: string;

  /**  */
  gender?: IEcgProfileGender;

  /**  */
  email?: string;

  /**  */
  phoneNumber?: string;

  /**  */
  rawReference?: string;
}

export interface Recipient {
  /**  */
  email: string;
}

export interface UpdatePasswordDto {
  /**  */
  password: string;

  /**  */
  sendPasswordUpdateEmail?: boolean;

  /**  */
  isOneTimePassword?: boolean;
}

export interface ContactUsDto {
  /**  */
  subject: string;

  /**  */
  body: string;

  /**  */
  contactMeAt?: string;
}

export interface ChangePasswordDto {
  /**  */
  oldPassword: string;

  /**  */
  newPassword: string;
}

export interface UpdateMeDto {
  /**  */
  firstName?: string;

  /**  */
  lastName?: string;

  /**  */
  salutation?: string;

  /**  */
  gender?: IUpdateMeDtoGender;

  /**  */
  beltSize?: IUpdateMeDtoBeltSize;

  /**  */
  dob?: string;

  /**  */
  hasPacemaker?: boolean;

  /**  */
  sendEcgsToMyself?: boolean;
}

export interface ForgotPasswordBase {
  /**  */
  email: string;
}

export interface ForgotPasswordDto {
  /**  */
  email: string;

  /**  */
  mobile?: number;
}

export interface ResetPasswordDto {
  /**  */
  token: string;

  /**  */
  newPassword: string;
}

export interface SendActivationEmailDto {
  /**  */
  email: string;

  /**  */
  type?: ISendActivationEmailDtoType;

  /**  */
  contactId?: string;
}

export interface ActivateAccountDto {
  /**  */
  token: string;

  /**  */
  password: string;

  /**  */
  licenseNumber?: string;
}

export interface ShApiResponse_List_GetOrganizationDomainDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetOrganizationDomainDto[];
}

export interface GetOrganizationDomainDto {
  /**  */
  organizationId: number;

  /**  */
  domain: string;
}

export interface ShApiResponse_TreeView_TreeViewNodeDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: TreeView_TreeViewNodeDto;
}

export interface TreeView_TreeViewNodeDto {
  /**  */
  nodeCount?: number;

  /**  */
  root?: TreeNode_TreeViewNodeDto;
}

export interface TreeNode_TreeViewNodeDto {
  /**  */
  data: TreeViewNodeDto;

  /**  */
  children?: TreeNode_TreeViewNodeDto[];
}

export interface TreeViewNodeDto {
  /**  */
  id: string;

  /**  */
  type: ITreeViewNodeDtoType;

  /**  */
  name: string;

  /**  */
  hasChildren: boolean;

  /**  */
  unviewedInPortal: boolean;

  /** Indicates whether the ECG has new info (interpretation/findings) that is unviewed by the requesting user */
  hasNewInfo: boolean;

  /** Indicates whether there is ECGs created in the last 24 hours */
  isExistEcgCreatedInLast24Hours: boolean;
}

export interface ShApiResponse_GetGeneralDetailsDto {
  /**  */
  error?: ApiError;

  /**  */
  response?: GetGeneralDetailsDto;
}

export interface GetGeneralDetailsDto {
  /**  */
  latestFirmwareVersion?: string;

  /**  */
  latestAppVersion?: string;

  /**  */
  hasNewEcgInfo?: boolean;

  /**  */
  systemMessages?: GetSystemMessageDto[];

  /**  */
  subscriptionDetails?: GetSubscriptionDetailsDto;
}

export interface GetSystemMessageDto {
  /**  */
  title?: string;

  /**  */
  body?: string;

  /**  */
  bullets?: string[];
}

export interface GetSubscriptionDetailsDto {
  /**  */
  status?: GetSubscriptionStatusDto;

  /**  */
  telehealthUrl?: string;
}

export interface GetSubscriptionStatusDto {
  /**  */
  avaliableNumberOfReviews?: number;

  /**  */
  status?: IGetSubscriptionStatusDtoStatus;
}

// export interface ShApiResponse_GetCountryCodesDto {
//   /**  */
//   error?: ApiError;

//   /**  */
//   response?: GetCountryCodeDto;
// }

// export type GetCountryCodeDto = string[]  //TODO change type when DTO is defined

type IApiErrorErrorCode =
  | 1
  | 2
  | 400
  | 401
  | 403
  | 404
  | 409
  | 500
  | 501
  | 1000
  | 2000
  | 3000
  | 4000
  | 4001
  | 6000;
type IGetDistributorDtoServiceType = 0 | 1 | -1;
type IEcgDataEcgReviewState = 0 | 1 | 2 | 3 | 4 | 5 | 6 | -1;
export type ICanRequestEcrOnDemandDtoState = 0 | 1 | 2;
export type ICanRequestEcrOnDemandDtoRejectReason =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 8
  | 9
  | 10;
type IUpdateSaveResponsePostSaveMessageCode = 1;
type IGetStaticLinksByRoleDtoLinkType = 1 | 2;
type IGetLatestFirmwareDtoActionType = 0 | 1 | 2;
type IGetSubjectDtoGender = 1 | 2 | 3;
type IGetSubscriptionDtoStatus = 0 | 1 | 2 | 3 | 9 | 10;
type IFullSmartheartUserRoleId = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
type IOrganizationOrganizationType = 0 | 1 | 2 | 3 | 4 | 5 | -1;
type IOrganizationServiceType = 0 | 1 | -1;
type IGetBasicUserDtoRoleId = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
type IGetUserDtoRoleId = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
type IGetUserDtoUserStatus = 0 | 1 | 2;
type IGetUserDtoGender = 1 | 2 | 3;
type IGetUserDtoBeltSize = 1 | 2 | 3 | 4;
type ICreateOrganizationUserDtoRoleId =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11;
type ICreateOrganizationUserDtoBeltSize = 1 | 2 | 3 | 4;
type IUpdateUserDtoBeltSize = 1 | 2 | 3 | 4;
type IUpdateUserDtoGender = 1 | 2 | 3;
type IGetEcgDtoReviewType = 1 | 2;
type IPortalOrganizationOrganizationType = 0 | 1 | 2 | 3 | 4 | 5 | -1;
type IPortalOrganizationServiceType = 0 | 1 | -1;
type IEcgProfileGender = 1 | 2 | 3;
type IUpdateMeDtoGender = 1 | 2 | 3;
type IUpdateMeDtoBeltSize = 1 | 2 | 3 | 4;
type ISendActivationEmailDtoType = 0 | 1;
type ITreeViewNodeDtoType = 0 | 1 | 2 | 3;
type IGetSubscriptionStatusDtoStatus = 0 | 1 | 2 | 3 | 9 | 10;
